// @flow

import mapSeries from 'async/mapSeries';

import App from './App.jsx';

import type {T_Escala} from './Escala.jsx';


// NOTE: SI USAS preload_escalas, Y QUIERES OBTENER EL PATH DE LA ESCALA, USA get_path_escala(), QUE VIVE EN Escala.jsx.
// NO USES LA PROPIEDAD pathScale.

export function preload_escalas(app: App, dir: string, next: (Array<T_Escala>) => void) {
  const item_dir = app.get_item_dir(dir);
  
  if (item_dir != null) {
    const pngs = item_dir.pngs
                .filter(png => png.props.node.File.indexOf('Mapa_Tematico_') === -1)
                .map(png => png.props.node.Path);
    
    mapSeries(pngs, (png, callback) => {
      const url = `${app.remote}/img-scale/?path=${png}&session_id=${app.session()}&host=${app.props.domain}`;
      
      fetch(url).then(resp => resp.json()).then((esc: T_Escala) => {
        callback(null, esc);
      });
    },
    (err, escs) => next(escs));
  }
  else {
    next([]);
  }
}



// WEBPACK FOOTER //
// ./src/make_book_util.js